module.exports = __webpack_public_path__ + "img/spinning-coin-front.b8deb026.png";